// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/CEFI_icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/pieGraphShadow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/images/pieGraphShading.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/images/pieSlice.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/images/pieSlice1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/images/pieSlice2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quote {
    width: 750px;
    padding: 20px;
}

/*Shrink the quotes for smaller screens*/
@media (max-width: 1100px) {
    .quote {
        transform: scale(0.9);
        transform-origin: top left;
    }
}
@media (max-width: 930px) {
    .quote {
        transform: scale(0.84);
        transform-origin: top left;
    }

    .mode-tabs {
        font-size: 0.9em;
    }
}
@media (max-width: 850px) {
    .quote {
        transform: scale(0.73);
        transform-origin: top left;
    }
}

.quote.full-scale {
    transform: scale(1);
}

.quote--header {
    vertical-align: top;
    font-size: 12px;
    margin-bottom: 20px;
}

.quote--header__left {
    display: inline-block;
    width: 60%;
    vertical-align: top;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 65px;
    background-repeat: no-repeat;
    padding-left: 70px;
    box-sizing: border-box;
}
.quote--header__right {
    display: inline-block;
    width: 40%;
    text-align: right;
    vertical-align: top;
}


.quote--header__left h1 {
    font-size: 1.5em;
    font-weight: bold;
    margin: 0 0 7px 0;
}
.quote--header__left h2, .quote--header__left h4 {
    font-size: 1.3em;
    font-weight: normal;
    display: inline-block;
    width: 50%;
    box-sizing: border-box;
    margin: 0 0 7px 0;
    padding-left: 5px;
}
.quote--header__left h4 {
    width: 100%;
    font-style: normal;
}
.quote--header__left h2:last-child {
    text-align: right;
}
.quote--header__left h3 {
    font-size: 1.1em;
    font-weight: normal;
    font-style: italic;
    color: #333;
    margin: 0;
    padding-left: 5px;
}



.quote--header__right h1 {
    font-size: 1.3em;
    font-weight: bold;
    margin: 0 0 7px 0;
    background-color: #DDD;
    text-align: center;
    padding: 5px;
}
.quote--header__right h2 {
    font-size: 1.1em;
    font-weight: normal;
    display: inline-block;
    width: 50%;
    box-sizing: border-box;
    margin: 0 0 7px 0;
}


.visualizations {
    margin-bottom: 20px;
}

.visualizations__left {
    position: relative;
    display: inline-block;
    width: 50%;
    vertical-align: top;
}
.visualizations__right {
    display: inline-block;
    width: 50%;
    vertical-align: top;
}

.visualizations__left h1 {
    font-size: 1.0em;
    font-weight: normal;
    margin: 0 0 7px 0;
}

.visualizations__right h1 {
    font-size: 1.0em;
    font-weight: normal;
    margin: 0 0 7px 0;
}


.details-section {
}

.details-section table {
    font-size: 0.85em;
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    table-layout: fixed;
}

.details-section table tr table {
    margin-bottom: 0;
}
.details-section table tr table tr td {
    padding: 0;
}


.details-section table tr td {
    padding: 0 10px;
    equal-width: auto;
}

.details-section table tr th {
    padding: 0 20px 0 0;
    equal-width: auto;
}

.details-section table tr td span.label {
    display: inline-block;
    width: 65%;
    padding: 5px 0;
    font-weight: bold;
}
.details-section table tr td span.value {
    display: inline-block;
    width: 35%;
    text-align: right;
}

.details-section table tr td table tr td {
    font-size: 1.15em;
}
.details-section table tr td table tr td span.label {
    width: auto;
}
.details-section table tr td table tr td span.value {
    float: none;
    padding-left: 1em;
}
.details-section table tr td table tr td:last-child {
    text-align: right;
}
.details-section table tr td table tr td:nth-child(2) {
    text-align: center;
}

.details-section h1 {
    font-size: 0.9em;
    font-weight: normal;
    margin: 0 0 7px 0;
    color: #555555;
}

.pie-chart-center-label {
    position: absolute;
    width: 100px;
    text-align: center;
    font-size: 20px;
    top: calc(30px);
    left: calc(50% - 50px);
    vertical-align: middle;
}

table.scholarship-enhancement-fund-extras {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}
table.scholarship-enhancement-fund-extras.achievers {
    margin-bottom: 20px;
    margin-top: 40px;
}
table.scholarship-enhancement-fund-extras tr td {
    padding: 0 10px;
    width: 25%;
    text-align: center;
}

.highest-paying-notice {
    font-weight: bold;
    text-align: center;
    margin: 20px 0;
}

.visualizations table {
    text-align: center;
}

.airmiles-plus {
    font-size: 1.1em;
    color: #3693cd;
    font-weight: bold;
    margin-bottom: 5px;
}

.info {
    color: #333;
    font-size: 0.85em;
}

.visualizations__right > div{
    margin-bottom: 20px;
    text-align: center;
}

.visualizations__right.self-initiated {
    position: relative;
    margin-top: 150px;
}
.visualizations__right.self-initiated > div:first-child {
    position: absolute;
    top: -150px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/* Define the wiggle animation */
@keyframes wiggle {
  0%, 100% {
    transform: rotate(12deg);
  }
  33% {
    transform: rotate(5deg);
  }
  50% {
    transform: rotate(13deg);
  }
  66% {
    transform: rotate(5deg);
  }
  86% {
    transform: rotate(10deg);
  }
}

img.visualizations__pie-piece {
    margin: 20px 0 10px 0;
}

.bold-currency {
    margin-top: 3px;
    font-weight: 500;
    font-size: 1.3em;
}

.bold-currency-small {
    margin-top: 3px;
    font-weight: 500;
    font-size: 1.0em;
}

.illustration-disclosure-page {
    position: absolute;
    top: 8%;
    right: 10px;

    font-size: 0.8em;
    font-weight: normal;
}

.illustration-disclosure {
    display: inline-block;
    position: relative;
}
.illustration-disclosure img {
    width: 100%;
    width: 750px;
}

.illustration-disclosure-signature-hider {
    position: absolute;
    background-color: white;
    width: 100%;
    box-sizing: border-box;
    height: 25%;
    bottom: 7%;
}

iframe {
    width: 100%;
    height: calc(100vh - var(--header-height) - 67px);
}

.maturity-summary {
    font-weight: bold;
    margin: 20px 10px;
    text-align: center;
}


.mode-selector {
    margin: 0 10px;
}

.mode-tabs {
    line-height: 1.5em;
    margin-bottom: 10px;
    width: calc(100vw - var(--nav-bar-width) - 20px);
}

.mode-tabs > span {
    display: inline-block;
}

.clb-only-indicator {
    padding-top: 125px;
}

.pie-chart-container {
    position: relative;
    margin-top: -20px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 315px 315px;
    background-repeat: no-repeat;
    background-position: 35px 35px;
}

.pie-chart-container .pie-chart-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 301px 301px;
    background-repeat: no-repeat;
    background-position: 35px 35px;
    opacity: 0.7;
}

.discretionary-payment-pie-slice {
    display: inline-block;
    width: 150px;
    height: 37px;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    margin: 5px 0;
}
.slice-1 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.slice-2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

hr {
    margin: 15px 0;
}`, "",{"version":3,"sources":["webpack://./src/Quotes/Quotes.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA,wCAAwC;AACxC;IACI;QACI,qBAAqB;QACrB,0BAA0B;IAC9B;AACJ;AACA;IACI;QACI,sBAAsB;QACtB,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,sBAAsB;QACtB,0BAA0B;IAC9B;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,mBAAmB;IACnB,yDAAqD;IACrD,qBAAqB;IACrB,4BAA4B;IAC5B,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;AACvB;;;AAGA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,UAAU;IACV,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,iBAAiB;AACrB;;;;AAIA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,UAAU;IACV,sBAAsB;IACtB,iBAAiB;AACrB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;;AAGA;AACA;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;;;AAGA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA,gCAAgC;AAChC;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,WAAW;;IAEX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,WAAW;IACX,iDAAiD;AACrD;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,yDAA0D;IAC1D,4BAA4B;IAC5B,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAA2D;IAC3D,4BAA4B;IAC5B,4BAA4B;IAC5B,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;IAC5B,yDAAoD;IACpD,aAAa;AACjB;AACA;IACI,yDAAqD;AACzD;AACA;IACI,yDAAqD;AACzD;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".quote {\n    width: 750px;\n    padding: 20px;\n}\n\n/*Shrink the quotes for smaller screens*/\n@media (max-width: 1100px) {\n    .quote {\n        transform: scale(0.9);\n        transform-origin: top left;\n    }\n}\n@media (max-width: 930px) {\n    .quote {\n        transform: scale(0.84);\n        transform-origin: top left;\n    }\n\n    .mode-tabs {\n        font-size: 0.9em;\n    }\n}\n@media (max-width: 850px) {\n    .quote {\n        transform: scale(0.73);\n        transform-origin: top left;\n    }\n}\n\n.quote.full-scale {\n    transform: scale(1);\n}\n\n.quote--header {\n    vertical-align: top;\n    font-size: 12px;\n    margin-bottom: 20px;\n}\n\n.quote--header__left {\n    display: inline-block;\n    width: 60%;\n    vertical-align: top;\n    background-image: url('/public/images/CEFI_icon.png');\n    background-size: 65px;\n    background-repeat: no-repeat;\n    padding-left: 70px;\n    box-sizing: border-box;\n}\n.quote--header__right {\n    display: inline-block;\n    width: 40%;\n    text-align: right;\n    vertical-align: top;\n}\n\n\n.quote--header__left h1 {\n    font-size: 1.5em;\n    font-weight: bold;\n    margin: 0 0 7px 0;\n}\n.quote--header__left h2, .quote--header__left h4 {\n    font-size: 1.3em;\n    font-weight: normal;\n    display: inline-block;\n    width: 50%;\n    box-sizing: border-box;\n    margin: 0 0 7px 0;\n    padding-left: 5px;\n}\n.quote--header__left h4 {\n    width: 100%;\n    font-style: normal;\n}\n.quote--header__left h2:last-child {\n    text-align: right;\n}\n.quote--header__left h3 {\n    font-size: 1.1em;\n    font-weight: normal;\n    font-style: italic;\n    color: #333;\n    margin: 0;\n    padding-left: 5px;\n}\n\n\n\n.quote--header__right h1 {\n    font-size: 1.3em;\n    font-weight: bold;\n    margin: 0 0 7px 0;\n    background-color: #DDD;\n    text-align: center;\n    padding: 5px;\n}\n.quote--header__right h2 {\n    font-size: 1.1em;\n    font-weight: normal;\n    display: inline-block;\n    width: 50%;\n    box-sizing: border-box;\n    margin: 0 0 7px 0;\n}\n\n\n.visualizations {\n    margin-bottom: 20px;\n}\n\n.visualizations__left {\n    position: relative;\n    display: inline-block;\n    width: 50%;\n    vertical-align: top;\n}\n.visualizations__right {\n    display: inline-block;\n    width: 50%;\n    vertical-align: top;\n}\n\n.visualizations__left h1 {\n    font-size: 1.0em;\n    font-weight: normal;\n    margin: 0 0 7px 0;\n}\n\n.visualizations__right h1 {\n    font-size: 1.0em;\n    font-weight: normal;\n    margin: 0 0 7px 0;\n}\n\n\n.details-section {\n}\n\n.details-section table {\n    font-size: 0.85em;\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n    table-layout: fixed;\n}\n\n.details-section table tr table {\n    margin-bottom: 0;\n}\n.details-section table tr table tr td {\n    padding: 0;\n}\n\n\n.details-section table tr td {\n    padding: 0 10px;\n    equal-width: auto;\n}\n\n.details-section table tr th {\n    padding: 0 20px 0 0;\n    equal-width: auto;\n}\n\n.details-section table tr td span.label {\n    display: inline-block;\n    width: 65%;\n    padding: 5px 0;\n    font-weight: bold;\n}\n.details-section table tr td span.value {\n    display: inline-block;\n    width: 35%;\n    text-align: right;\n}\n\n.details-section table tr td table tr td {\n    font-size: 1.15em;\n}\n.details-section table tr td table tr td span.label {\n    width: auto;\n}\n.details-section table tr td table tr td span.value {\n    float: none;\n    padding-left: 1em;\n}\n.details-section table tr td table tr td:last-child {\n    text-align: right;\n}\n.details-section table tr td table tr td:nth-child(2) {\n    text-align: center;\n}\n\n.details-section h1 {\n    font-size: 0.9em;\n    font-weight: normal;\n    margin: 0 0 7px 0;\n    color: #555555;\n}\n\n.pie-chart-center-label {\n    position: absolute;\n    width: 100px;\n    text-align: center;\n    font-size: 20px;\n    top: calc(30px);\n    left: calc(50% - 50px);\n    vertical-align: middle;\n}\n\ntable.scholarship-enhancement-fund-extras {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n}\ntable.scholarship-enhancement-fund-extras.achievers {\n    margin-bottom: 20px;\n    margin-top: 40px;\n}\ntable.scholarship-enhancement-fund-extras tr td {\n    padding: 0 10px;\n    width: 25%;\n    text-align: center;\n}\n\n.highest-paying-notice {\n    font-weight: bold;\n    text-align: center;\n    margin: 20px 0;\n}\n\n.visualizations table {\n    text-align: center;\n}\n\n.airmiles-plus {\n    font-size: 1.1em;\n    color: #3693cd;\n    font-weight: bold;\n    margin-bottom: 5px;\n}\n\n.info {\n    color: #333;\n    font-size: 0.85em;\n}\n\n.visualizations__right > div{\n    margin-bottom: 20px;\n    text-align: center;\n}\n\n.visualizations__right.self-initiated {\n    position: relative;\n    margin-top: 150px;\n}\n.visualizations__right.self-initiated > div:first-child {\n    position: absolute;\n    top: -150px;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n/* Define the wiggle animation */\n@keyframes wiggle {\n  0%, 100% {\n    transform: rotate(12deg);\n  }\n  33% {\n    transform: rotate(5deg);\n  }\n  50% {\n    transform: rotate(13deg);\n  }\n  66% {\n    transform: rotate(5deg);\n  }\n  86% {\n    transform: rotate(10deg);\n  }\n}\n\nimg.visualizations__pie-piece {\n    margin: 20px 0 10px 0;\n}\n\n.bold-currency {\n    margin-top: 3px;\n    font-weight: 500;\n    font-size: 1.3em;\n}\n\n.bold-currency-small {\n    margin-top: 3px;\n    font-weight: 500;\n    font-size: 1.0em;\n}\n\n.illustration-disclosure-page {\n    position: absolute;\n    top: 8%;\n    right: 10px;\n\n    font-size: 0.8em;\n    font-weight: normal;\n}\n\n.illustration-disclosure {\n    display: inline-block;\n    position: relative;\n}\n.illustration-disclosure img {\n    width: 100%;\n    width: 750px;\n}\n\n.illustration-disclosure-signature-hider {\n    position: absolute;\n    background-color: white;\n    width: 100%;\n    box-sizing: border-box;\n    height: 25%;\n    bottom: 7%;\n}\n\niframe {\n    width: 100%;\n    height: calc(100vh - var(--header-height) - 67px);\n}\n\n.maturity-summary {\n    font-weight: bold;\n    margin: 20px 10px;\n    text-align: center;\n}\n\n\n.mode-selector {\n    margin: 0 10px;\n}\n\n.mode-tabs {\n    line-height: 1.5em;\n    margin-bottom: 10px;\n    width: calc(100vw - var(--nav-bar-width) - 20px);\n}\n\n.mode-tabs > span {\n    display: inline-block;\n}\n\n.clb-only-indicator {\n    padding-top: 125px;\n}\n\n.pie-chart-container {\n    position: relative;\n    margin-top: -20px;\n    background-image: url('/public/images/pieGraphShadow.png');\n    background-size: 315px 315px;\n    background-repeat: no-repeat;\n    background-position: 35px 35px;\n}\n\n.pie-chart-container .pie-chart-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url('/public/images/pieGraphShading.png');\n    background-size: 301px 301px;\n    background-repeat: no-repeat;\n    background-position: 35px 35px;\n    opacity: 0.7;\n}\n\n.discretionary-payment-pie-slice {\n    display: inline-block;\n    width: 150px;\n    height: 37px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-image: url('/public/images/pieSlice.png');\n    margin: 5px 0;\n}\n.slice-1 {\n    background-image: url('/public/images/pieSlice1.png');\n}\n.slice-2 {\n    background-image: url('/public/images/pieSlice2.png');\n}\n\nhr {\n    margin: 15px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
